import qs from 'query-string';
import { get, post, put, del } from './baseApi';

export const UserTypeApi = {
    fetch: (query) => get(`/users/types?${qs.stringify(query)}`),
    create: (data) => post('/users/types', data),
    update: (id, data) => put(`/users/types/${id}`, data),
    delete: (id) => del(`/users/types/${id}`),
};
